<script lang="ts">
// @ts-nocheck
import { Line } from "vue-chartjs";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  extends: Line,
})
export default class SpendingChart extends Vue {
  @Prop({ required: true }) chartData!: any;
  @Prop() options!: any;

  public mounted(): void {
    this.renderChart(this.chartData, this.options);
  }
}
</script>
